/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { useFormikContext } from 'formik'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  PLUGIN_SCHEDULE_VIEW_OPTIONS,
  type PluginEmbedSettings,
  type PluginScheduleView,
} from '@sportninja/common/features/account/apiAccess'
import { SegmentedInput } from 'src/components/ts-components/SegmentedInput'
import { SwitchField, TextField } from '../../../components/FormikField'
import { PLUGIN_DISPLAY_FLAGS } from '../../constants/pluginSettings'
import { FooterField } from './FooterField'

const SCHEDULE_VIEW_OPTIONS = PLUGIN_SCHEDULE_VIEW_OPTIONS.map(
  ({ label, value }) => ({ label: capitalizeWords(label), value })
)

/** Header, schedule view, footer and the announcements feed. */
export const DisplayGroup = () => {
  const { values, setFieldValue } = useFormikContext<PluginEmbedSettings>()

  return (
    <div css={groupStyle}>
      {PLUGIN_DISPLAY_FLAGS.map(({ name, label, hint }) => (
        <SwitchField
          key={name}
          name={name}
          label={capitalizeWords(label)}
          hint={hint}
        />
      ))}
      <SegmentedInput
        label={capitalizeWords('Schedule View')}
        options={SCHEDULE_VIEW_OPTIONS}
        value={values.display.scheduleView ?? 'rows'}
        onChange={(next: PluginScheduleView) =>
          // Rows is the plugin's default: no value.
          setFieldValue('display.scheduleView', next === 'rows' ? null : next)
        }
      />
      <FooterField />
      <TextField
        name='display.feedOrgId'
        label={capitalizeWords('Feed Org ID')}
        placeholder={capitalizeWords('Feed Org ID')}
        hint="Communication tabs show this organization's posts instead of their own"
        emptyValue='null'
      />
    </div>
  )
}

const groupStyle = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
